import React from "react";

function Partners() {
    return(
        <h1>
        This is the parners pag</h1>
    );
}

export default Partners;